export enum ProgramType {
  Elementary = 1,
  High
}
